export const transformUserRegisterForm = (data: any, isOnlyOffsetter = false) => {
  return {
    email: data.credentials.email,
    password: data.credentials.password,
    password_confirmation: data.credentials.confirmPassword,
    first_name: data.personalData.firstName,
    last_name: data.personalData.lastName,
    phone: data.credentials.phone,
    invitationCode: '',
    company_name: data.personalData.companyName,
    Company_website: '-',
    is_widget: false,
    is_business: true,
    groups: isOnlyOffsetter ? ['offsetters'] : ['producers', 'offsetters'],
    language: 'en',
    country: data.personalData.country,
    company_country: data.personalData.country,
    mint_nft: false
  }
}
